import toast from 'react-hot-toast';

/**
 * Display an errorand log it to Sentry.
 * @param error The error to capture, either as an Error object or a string message.
 */
export function displayError(error: Error | string, messageOverride?: string) {
  const message = messageOverride || (typeof error === 'string' ? error : error.message);
  console.error(error);
  toast.error(message, {
    duration: 10_000,
  });
}
